import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environment/environment';
import { ApiAbstractService } from './api-abstract.service';
import { SearchEngineTypeValue, SearchType, SearchEngineTypeLabel } from 'modules/shared/models/screening.models';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export var ASYNC_SEARCH_ENGINES = [
    SearchEngineTypeValue.DJ,
    SearchEngineTypeValue.DJ2,
    SearchEngineTypeValue.DJ3,
    SearchEngineTypeValue.TR,
    SearchEngineTypeValue.ARTEMISCAN,
];
var ScreeningService = /** @class */ (function (_super) {
    tslib_1.__extends(ScreeningService, _super);
    function ScreeningService(httpClient) {
        var _this = _super.call(this, environment.API_BASE) || this;
        _this.httpClient = httpClient;
        return _this;
    }
    // FIXME: Later on talk to BE guys to make API(name, url, params) more consistency
    // Set end url and parrams based in engine value
    // BE is using inconsistent name for internet search
    ScreeningService.prototype.setUrlAndParrams = function (engine, parrams) {
        if (parrams === void 0) { parrams = {}; }
        var uap = {
            parrams: parrams,
            url: ''
        };
        if (engine === SearchEngineTypeValue.INTERNET_SEARCH || engine === SearchEngineTypeValue.NLP) {
            uap.url = "internet_searches/";
            uap.parrams.version = 'V2';
        }
        else if (engine === SearchEngineTypeValue.OWN_NAME) {
            uap.url = "own_name_searches/";
        }
        else {
            parrams.engine_type = engine;
            uap.url = "searches/";
        }
        return uap;
    };
    ScreeningService.prototype.getQuickScanById = function (id) {
        return this.httpClient.get(this.buildUrl("/quickscan/records/" + id + "/"));
    };
    // Get all comments of a quick scan result
    ScreeningService.prototype.getQuickScanCommentById = function (id) {
        return this.httpClient.get(this.buildUrl("/quickscan/records/" + id + "/posts/"));
    };
    // Submit a new comment to a quickscan result
    ScreeningService.prototype.submitQuickScanCommentById = function (id, comment) {
        return this.httpClient.post(this.buildUrl("/quickscan/records/" + id + "/posts/"), comment);
    };
    // Get quick scan by id, engine & parrams
    ScreeningService.prototype.getQuickScan = function (id, engineType, parrams) {
        var url = "/quickscan/records/" + id + "/";
        var uap = this.setUrlAndParrams(engineType, parrams);
        url += uap.url;
        return this.httpClient.get(this.buildUrl(url, uap.parrams))
            .pipe(map(function (res) { return (tslib_1.__assign({}, res, { engineType: engineType, searchType: SearchType.QUICKSCAN })); }));
    };
    ScreeningService.prototype.getQuickScanCsv = function () {
        return this.httpClient.get(this.buildUrl("/quickscan/csv/"), {
            responseType: 'blob'
        });
    };
    // Record screening by id, engineType
    ScreeningService.prototype.postScreening = function (payload, engineType, parrams) {
        var url = "/api/records/" + payload.recordId + "/";
        var uap = this.setUrlAndParrams(engineType, parrams ? parrams : {});
        url += uap.url;
        uap.parrams.base_url = JSON.stringify(payload);
        return this.httpClient.post(this.buildUrl(url), uap.parrams);
    };
    // Get screening by id, engine & parrams
    ScreeningService.prototype.getScreening = function (id, engineType, parrams) {
        // let url = this.apiBase;
        var url = "/api/records/" + id + "/";
        var uap = this.setUrlAndParrams(engineType, parrams);
        url += uap.url;
        return this.httpClient.get(this.buildUrl(url, uap.parrams))
            .pipe(map(function (res) { return (tslib_1.__assign({}, res, { id: id, engineType: engineType, searchType: SearchType.SCREENING })); }));
    };
    // update individual screening result macthed status
    ScreeningService.prototype.patchSearchResult = function (payload) {
        var searchUrl = 'search_results';
        if (payload && payload.isInternet) {
            searchUrl = 'internet_search_results';
        }
        else if (payload && payload.isOwnName) {
            searchUrl = 'own_name_search_results';
        }
        return this.httpClient.patch(this.buildUrl("/api/" + searchUrl + "/" + payload.id + "/"), { matched: payload.status });
    };
    // Update comment and matched status by batch
    ScreeningService.prototype.batchUpdateSearchResult = function (payload) {
        var searchUrl = 'search_results';
        if (payload && payload.isInternet) {
            searchUrl = 'internet_search_results';
        }
        else if (payload && payload.isOwnName) {
            searchUrl = 'own_name_search_results';
        }
        return this.httpClient.put(this.buildUrl("/api/" + searchUrl + "/batch/"), payload.updateToSend);
    };
    // Get quick scan list
    ScreeningService.prototype.getQuickScanList = function (queries) {
        return this.httpClient.get(this.buildUrl("/quickscan/search/", queries));
    };
    ScreeningService.prototype.getODDs = function (queries) {
        return this.httpClient.get(this.buildUrl('/api/ongoing_due_diligence/', queries));
    };
    ScreeningService.prototype.getCrpList = function (queries) {
        return this.httpClient.get(this.buildUrl('/api/customers/', queries));
    };
    ScreeningService.prototype.getSearchesODD = function (id) {
        return this.httpClient.get(this.buildUrl("/api/searches/" + id + "/"));
    };
    ScreeningService.prototype.getInternetSearchesODD = function (id) {
        return this.httpClient.get(this.buildUrl("/api/internet_searches/" + id + "/")).pipe(map(function (res) { return (tslib_1.__assign({}, res, { engineType: SearchEngineTypeValue.INTERNET_SEARCH })); }));
    };
    ScreeningService.prototype.getOwnNameSearchesODD = function (id) {
        return this.httpClient.get(this.buildUrl("/api/own_name_searches/" + id + "/")).pipe(map(function (res) { return (tslib_1.__assign({}, res, { engineType: SearchEngineTypeValue.OWN_NAME })); }));
    };
    ScreeningService.prototype.getODDById = function (id) {
        return this.httpClient.get(this.buildUrl("/api/ongoing_due_diligence/" + id));
    };
    ScreeningService.prototype.checkValidSearch = function (recordIds, searchEngines) {
        var _this = this;
        var searchObs = [];
        recordIds.forEach(function (id) {
            searchEngines.map(function (searchEngine) { return (searchEngine).serviceType; })
                .forEach(function (engine) {
                searchObs.push(_this.getScreening(id, engine, { limit: 1 })
                    .pipe(catchError(function (error) {
                    return of({
                        count: 0,
                        engineType: engine,
                        searchType: 'SCREENING',
                        next: null,
                        prev: null,
                        results: [],
                        error: error.message || error
                    });
                })));
            });
        });
        return forkJoin(searchObs)
            .pipe(map(function (searches) { return searches.map(function (search) {
            return {
                record: search.id,
                valid: search.results.length > 0 ? search.results[0].valid : false,
                engine: search.engineType
            };
        }); }));
    };
    /**
     * Get label to show on UI for the engineType
     * @method getSearchEngineLabel
     */
    ScreeningService.prototype.getSearchEngineLabel = function (engineType) {
        try {
            var engineTypeName = Object.keys(SearchEngineTypeValue).find(function (keyName) { return SearchEngineTypeValue[keyName] === engineType; });
            return SearchEngineTypeLabel[engineTypeName];
        }
        catch (error) {
            return 'Unknown';
        }
    };
    ScreeningService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScreeningService_Factory() { return new ScreeningService(i0.ɵɵinject(i1.HttpClient)); }, token: ScreeningService, providedIn: "root" });
    return ScreeningService;
}(ApiAbstractService));
export { ScreeningService };
